import { Component } from "@angular/core";
import { Select } from "@ngxs/store";
import { UserState } from "./states/user.state";
import { filter, Observable } from "rxjs";
import { Place } from "./interface/user";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { NotFoundComponent } from "./not-found/not-found/not-found.component";
import { SiteInMaintenanceComponent } from "./site-in-maintenance/site-in-maintenance.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  @Select(UserState.selectedPlace) selectedPlace: Observable<Place>;
  @Select(UserState.isAuthenticated) isAuthenticated$: Observable<boolean>;
  showSidenav = true;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const currentRoute = this.getChild(this.route);
        const component = currentRoute.snapshot.component;

        this.showSidenav =
          component !== NotFoundComponent &&
          component !== SiteInMaintenanceComponent;
      });
  }

  getChild(route: ActivatedRoute): ActivatedRoute {
    if (route.firstChild) {
      return this.getChild(route.firstChild);
    }
    return route;
  }
  toolbarHeight = () => {
    const toolbar = document.getElementById("toolbar");
    return {
      "margin-top": `${toolbar.clientHeight}px`,
    };
  };
}
